module.exports = __webpack_public_path__ + "img/land_01_new2.fbbb5006.jpg";